export enum MapLocations {
  businessAddress = 'Business Address',
  startingLocation = 'Starting Location',
  signingLocation = 'Signing Location',
}
